<div class="app-confirm-dialog__overlay" *ngIf="overlay || isLoading" (click)="closeDialog()">
	<div class="loading-wrapper" *ngIf="isLoading">
		<app-loading></app-loading>		
	</div>
</div>
<!--
<div class="app-confirm-dialog__content" id="app-confirm-dialog" tabindex="0" role="dialog" [attr.aria-label]="ariaLabel"
*ngIf="!isLoading">
-->
<div class="app-confirm-dialog__content" id="app-confirm-dialog" tabindex="0" role="dialog" [attr.aria-label]="ariaLabel">
	<ng-content></ng-content>
</div>
